import { render } from "./Show.vue?vue&type=template&id=67d0f462&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=67d0f462&lang=scss&scoped=true"
import "./Show.vue?vue&type=style&index=1&id=67d0f462&lang=css"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d0f462"]])

export default __exports__